<template>
  <section class="d-flex allRandomTools">
    <div v-for="tool in randomTools" class="toolTemplateDiv" :key="tool">
      <StartScreenToolTemplate :tool="tool" class="toolHover" />
    </div>
  </section>
</template>

<script>
import StartScreenToolTemplate from "./StartScreenToolTemplate";
export default {
  name: "StartScreenTools",
  props: {
    randomTools: Array,
  },
  components: { StartScreenToolTemplate },
};
</script>

<style scoped>
* {
  transition: background-color 0.4s;
}
.toolTemplateDiv:hover {
  box-shadow: 0 4px 12px 0 rgb(128 126 142 / 75%),
    0 2px 30px 0 rgb(121 119 133 / 15%);
  background-color: #f8f8ff;
  transition: background-color 0.4s;
}
.toolTemplateDiv {
  display: flex;
  justify-content: center;
}
.toolTemplateDiv:hover.toolHover p:hover {
  color: white !important;
}
.toolTemplateDiv {
  margin: 11px;
  margin-top: 28px;
}

.allRandomTools {
  width: 502px;
  flex-wrap: wrap;
  justify-content: center;
  /* margin-left: auto;
  margin-right: auto; */
}
* {
  align-self: center;
}
div {
  height: 107px;
  width: 103px;
  border-radius: 10px;
  background-color: var(--white);
}

@media only screen and (max-width: 600px) {
  .allRandomTools {
    width: inherit;
  }

  div {
    height: 85px;
    width: 85px;
  }

  .toolTemplateDiv {
    margin-top: 5px;
  }
}
</style>